import { render, staticRenderFns } from "./BillDown.vue?vue&type=template&id=6774b9f8"
import script from "./BillDown.vue?vue&type=script&lang=js"
export * from "./BillDown.vue?vue&type=script&lang=js"
import style0 from "./BillDown.vue?vue&type=style&index=0&id=6774b9f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports